import { FaBell, FaPlayCircle, FaRobot, FaHandPaper } from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';
import React, { useContext, useState } from 'react';

import { AiOutlineFileSearch } from 'react-icons/ai';
import Assistant from '../../../chatgpt_summarize/Assistant';
import { HeaderContext } from './header/HeaderContext';
import Help from './header/Help';
import Notifications from './header/Notifications';
import PropTypes from 'prop-types';
import UserMenu from './header/UserMenu';
import { useLocation } from 'react-router-dom';
import { useTour } from '../../../store/context/tour.context';
import { v4 as uuid } from 'uuid';

function Header({ sidebarOpen, setSidebarOpen, user }) {
  const { titleHeader } = useContext(HeaderContext);
  const [showVideo, setShowVideo] = useState(false);
  const [sidebarStatus, setSidebarStatus] = useState(false);
  const [convoId, setconvoId] = useState('');

  const {
    startTour,
    startBrandIntelTour,
    startTrackCompaniesTour,
    startLinkedinPublicTour,
    startLinkedinOwnedTour,
  } = useTour();

  const handleGuideClick = () => {
    const path = location.pathname;
    if (path === '/brandintel/dashboard') {
      startBrandIntelTour();
    } else if (path === '/' || path.includes('/brandintel/trackcompanies')) {
      startTrackCompaniesTour();
    } else if (path.includes('/linkedin/insights')) {
      startLinkedinPublicTour();
    } else if (path.includes('/linkedin/owned-account')) {
      startLinkedinOwnedTour();
    } else {
      startTour();
    }
  };

  // Function to toggle the visibility of the summary UI component

  const toggleVideo = () => {
    setShowVideo(!showVideo);
  };

  const navigate = useNavigate();

  const video_link = {
    'Lead Insight': {
      url: 'https://www.loom.com/embed/24ce31011d71413eb1f635efc2106e1d?sid=75f7ca25-aa6a-4658-ac5e-6a6b1585906c',
    },
    'Socialmedia Insight': {
      url: 'https://www.loom.com/embed/581a95e7cbba44a08cd4b596393cff85?sid=b05e46ba-ff34-4889-887c-fe5afc10e290',
    },
    'Company Insight': {
      url: 'https://www.loom.com/embed/6e828c6d87a946bfbd3d63964b7342e8?sid=30650d64-ce1d-439e-91c2-c3e1d1cfa62e',
    },
    'Actionable Insight': {
      url: 'https://www.loom.com/embed/9346e7e20adf43d19bcff83d976c32f9?sid=d165221b-ac32-4e69-b0e0-8965064b37bc',
    },
    'Facebook Insight': {
      url: 'https://www.loom.com/embed/a95e54c013ca48ca8f7eec69e2c00b2f?sid=7aadc837-a7f3-44b8-ac44-aff7dbe01a40',
    },
    'Linkedin Insight': {
      url: 'https://www.loom.com/embed/47a9e2b25ebb48d5a6e3cfa8078ed7e0?sid=f5f688b1-4313-49e3-9586-afde40ac0719',
    },
  };
  const location = useLocation();
  let videoUrl;

  switch (true) {
    case location.pathname.includes('lead/generation'):
    case location.pathname.includes('/lead/jobinsights'):
    case location.pathname.includes('/lead/salesleadinsights'):
      videoUrl = video_link['Lead Insight'].url;
      break;

    case location.pathname.includes('/lead/socialmediainsights'):
      videoUrl = video_link['Socialmedia Insight'].url;
      break;

    case location.pathname.includes('/companyinsights/companydetails'):
      videoUrl = video_link['Company Insight'].url;
      break;

    case location.pathname.includes('/socialinsights'):
    case location.pathname.includes('/brandintel/trackcompanies'):
    case location.pathname.includes('/brandintel/dashboard'):
    case location.pathname.includes('/brandintel/comparisonhub'):
    case location.pathname.includes('/profile'):
      videoUrl = video_link['Actionable Insight'].url;
      break;

    case location.pathname.includes('/ad/facebook'):
    case location.pathname.includes('ad/trends'):
      videoUrl = video_link['Facebook Insight'].url;
      break;

    case location.pathname.includes('/linkedin/owned-account'):
    case location.pathname.includes('/linkedin/insights'):
    case location.pathname.includes('/linkedin/user'):
      videoUrl = video_link['Linkedin Insight'].url;
      break;

    default:
      videoUrl = video_link['Actionable Insight'].url;
      break;
  }

  return (
    <>
      <header className="sticky top-0 bg-white border-b border-slate-200 z-[30]">
        <div className="px-2 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 -mb-px">
            {/* Header: Left side */}
            <div className="flex mr-2 sm:mr-4">
              {/* Hamburger button */}

              <button
                className="text-slate-500 hover:text-slate-600 lg:hidden"
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  className="w-6 h-6 fill-current"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="4" y="5" width="16" height="2" />
                  <rect x="4" y="11" width="16" height="2" />
                  <rect x="4" y="17" width="16" height="2" />
                </svg>
              </button>
              <NavLink end to="/" className="block">
                <img
                  src="/avatars/HAIXforwebsite.png"
                  className="lg:sidebar-expanded:hidden ml-2 h-auto w-16 sm:w-24"
                  alt="logo"
                />
              </NavLink>
            </div>
            {/* Title — takes remaining space, truncates when sidebar is open */}
            <div className="flex-1 min-w-0 px-2 flex items-center justify-center">
              <h3 className="truncate text-center text-gray-700 text-[13px] sm:text-[16px] lg:text-[18px] font-semibold leading-tight">
                {titleHeader ? titleHeader : ''}
              </h3>
            </div>

            {/* Header: Right side — never shrinks or wraps */}
            <div className="flex-shrink-0 flex items-center gap-2">
              {/* AI Assistant Button */}
              <button
                onClick={() => { navigate('/genai-live'); }}
                className="flex items-center gap-1.5 bg-white border border-gray-300 text-gray-800 font-medium px-2.5 py-1.5 rounded-xl shadow-sm hover:shadow-md transition-transform transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-gray-400"
                title="omniO AI Assistant"
              >
                <AiOutlineFileSearch className="text-[15px] text-gray-700 flex-shrink-0" />
                <span className="hidden lg:inline text-[13px] text-gray-700 whitespace-nowrap">omniO AI Assistant</span>
              </button>

              {/* Guide Button */}
              <button
                onClick={handleGuideClick}
                className="flex items-center gap-1.5 bg-white border border-gray-300 text-gray-800 font-medium px-2.5 py-1.5 rounded-xl shadow-sm hover:shadow-md transition-transform transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-gray-400"
                title="Take a guided tour of this page"
              >
                <span className="material-icons text-[15px] text-gray-700 flex-shrink-0">help_outline</span>
                <span className="hidden lg:inline text-[13px] text-gray-700 whitespace-nowrap">Guide</span>
              </button>

              {/* Notifications Bell */}
              <button
                onClick={() => navigate('/alerts')}
                className="flex items-center justify-center p-1.5 text-gray-700 hover:text-gray-900 transition-transform transform hover:scale-110 active:scale-95 focus:outline-none"
                title="Alerts"
              >
                <FaBell className="text-[18px]" />
              </button>

              {/* Watch Demo Button */}
              <button
                onClick={toggleVideo}
                className="flex items-center justify-center p-1.5 text-gray-700 hover:text-gray-900 transition-transform transform hover:scale-110 active:scale-95 focus:outline-none"
                title="Watch Demo"
              >
                <FaPlayCircle className="text-[18px]" />
              </button>

              {/* Divider */}
              <hr className="w-px h-6 bg-slate-200 mx-1" />
              <UserMenu user={user} />
              <hr className="w-px h-6 bg-slate-200 mx-1" />
              <NavLink
                to="/privacy-policy"
                className="flex items-center justify-center p-1.5 text-gray-700 hover:text-gray-900 transition-transform transform hover:scale-110 active:scale-95 focus:outline-none"
                title="Privacy Policy"
              >
                <FaHandPaper className="text-[18px]" />
              </NavLink>
              <hr className="w-px h-6 bg-slate-200 mx-1" />
              <Help />
            </div>
          </div>
        </div>
      </header>
      {showVideo && (
        <div className="fixed top-0 left-0 w-full h-full flex items-start p-5 justify-end bg-black bg-opacity-50 z-50">
          <div className="relative">
            <button
              className="absolute top-0 right-0 m-4 text-white text-2xl cursor-pointer"
              onClick={toggleVideo}
            >
              &times;
            </button>
            <iframe
              width="560"
              height="315"
              src={videoUrl}
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              title="Demo Video"
            ></iframe>
          </div>
        </div>
      )}

      <Assistant
        sidebarStatus={sidebarStatus}
        setSidebarStatus={setSidebarStatus}
        convoId={convoId}
        setconvoId={setconvoId}
      />
    </>
  );
}

Header.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    email_verified: PropTypes.bool,
    name: PropTypes.string,
    nickname: PropTypes.string,
    picture: PropTypes.string,
    sub: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  sidebarOpen: PropTypes.bool,
  setSidebarOpen: PropTypes.func,
};

export default React.memo(Header);
